import { RightFloatingButtonScalor } from "../../editor_common_components";
import { Button } from "../../../core/components/button";
import { Dialog, DialogProps } from "../../../core/components/dialog";
import { TextBox, TextBoxField } from "../../../core/components/textBox";
import { FAIcon } from "../../../core/components/faIcon";
import CRTagsGrid from "../../../crReport/crTagsGrid";
import React from "react";
export class TagsPicker extends React.Component<{ onTextChange: any, value: string, label: string }, { showDialog: boolean }>{
    constructor(props) {
        super(props);
        this.state = { showDialog: false };
    }

    handleSave = (name) => {
        this.setState({ showDialog: false });
        this.props.onTextChange(name);
    }

    render() {
        const dialog = this.state.showDialog ? <TagsEditor value={this.props.value || []}
            onClose={() => this.setState({ showDialog: false })}
            onSave={this.handleSave}></TagsEditor> : null;
        return (
            <li>
                {dialog}
                <div title={this.props.label}>
                    <span className="property-name">
                        <RightFloatingButtonScalor>
                            <Button iconName="edit" title="Edit" handleClick={() => this.setState({ showDialog: true })}></Button>
                        </RightFloatingButtonScalor>
                        {this.props.label}
                    </span>
                    <div className="c" style={{ "whiteSpace": "nowrap" }}>
                        Tags
                    </div>
                </div>
            </li>
        );
    }
};

export class TagsEditor extends React.Component<{ onSave, onClose, value }, {}>{

    private entity: any;
    private dialogProps: DialogProps = {
        title: "Edit tags",
        actions: [
            {
                label: "Cancel",
                action: () => {
                    this.props.onClose();
                    return true;
                }
            },
            {
                label: "Save",
                action: () => {
                    this.props.onSave(this.entity.Tags);
                },
                primary: true
            }],
        afterClose: () => {
        },
        width: 500,
        open: true
    }

    constructor(props) {
        super(props)
        this.entity = {};
    }

    private textBoxProps: TextBoxField = {
        type: "text",
        model: "",
        triggerOnChange: true
    }

    
    render() {

        return (<Dialog {...this.dialogProps}>
            <CRTagsGrid
                entity={this.entity}
                value={this.props.value}
                context={{}}
                disabled={false}>
            </CRTagsGrid>

        </Dialog>

        );
    }
};